export const state = {
    orcamento: {
        subtotal: 0,
        desconto: 0,
        total: 0,
        cliente_id: 1,
        itens:[],
        formas_pagamentos: [],
    },
    orcamentos: [],
    infoProposta: {
        loja: "Piscina, cavação, instalação hidráulica com tubulação de 50mm, 1ª limpeza com nossos produtos, equipamentos (casa de maquina, filtro e bomba) e ponto de cascata, kit acessório (cabo, peneira, aspirador, escovão, ponteira, adaptador e mangueira), hidro (retorno), 02 ralo de fundo com tampa de proteção ante-sucção.",  
        cliente: "Água, ponto de energia 110 ou 220 com 01 disjuntor dentro da casa de máquina com uma haste de aterramento de 1 metro com conecto, complemento de dreno e retirada do aterro da frente da sua casa/obra, terreno livre para cavação,retirada de cerca elétrica, caso haja e reposição de telha.",
        validade: "30 dias",
        prazo_entrega: "8 a 15 dias"
    },
    itensOrcamento: [],
    itemOrcamento: {
        produto_id: '',
        descricao: '',
        preco: '',
        quantidade: '',
        total: '',
    },
    getModalCadastroOrcamento: false,
    modalExcluirOrcamento: false,
    modalPesquisarProdutosOrcamento: false,
    modalAdicionarProdutoOrcamento: false,
    modalImprimirOrcamento: false,
    modalEnviarEmailOrcamento: false,
    modalInfoProposta: false
}

export default {}